import {useState, useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {useFirestoreConnect, isEmpty, isLoaded} from 'react-redux-firebase';
import {isArray, uniqBy} from 'lodash'

import {gotKeywords} from "../redux/slices/keyword.slice";

const format = (docs) => {
    let raw = [];

    docs.forEach(item => {
        if (isArray(item?.keyWords)) {
            const meta = item?.keyWords?.map(one => ({...one, docId: item?.id})) || []
            raw = [...raw, ...meta]
        }
        if (isArray(item?.keyWord)) {
            const meta = item?.keyWords?.map(one => ({...one, docId: item?.id})) || []
            raw = [...raw, ...meta]
        }
    })

    raw = uniqBy(raw, 'id')?.map(one => ({...one, _helper: `${one?.name} ${one?.internalId} ${one?.barCode}`}))

    return {
        raw,
        keywords: raw.map(({docId, ...rest}) => ({...rest})),
        lastDoc: docs?.find(one => one?.id === 'RefKeyWord')?.key
    };
}

export default function useKeywords() {
    const dispatch = useDispatch()
    const getData = useSelector(state => state.firestore.ordered.keywords);

    const [loading, setLoading] = useState(true);
    const result = useMemo(() => isEmpty(getData) ? {} : format(getData), [getData]);
    const {keywords = [], raw = [], lastDoc = null} = useMemo(() => result, [result]);

    useEffect(() => {
        dispatch(gotKeywords(result))
        // eslint-disable-next-line
    }, [result]);

    useEffect(() => setLoading(!isLoaded(getData)), [getData]);

    useFirestoreConnect(() => [{collection: 'keyWords', storeAs: 'keywords'}]);

    return {keywords, raw, loading, lastDoc}
}
